import { Map } from 'immutable';

import { aiGenerated, aiGeneratedV2 } from './ai';
import { tagsToList, tagsToString } from '../../../tags';
import { isFeatureEnabled } from '../../../featureFlags';
import { getSize } from '../../../iterable/getSize';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { FEATURES } from '../../../../constants/billing';
import ATTRIBUTE from '../../../../constants/attributes';

export function tags({ channel, operation, preview, state, userId }) {
  switch (operation) {
    case OPERATIONS[channel].TAGS.AI_GENERATED: {
      return isFeatureEnabled({ feature: FEATURES.AI_V2, userId })
        ? aiGeneratedV2({ attribute: ATTRIBUTE.TAGS, channel, preview, state })
        : aiGenerated({
          attribute: ATTRIBUTE.TAGS,
          operation: OPERATIONS[channel].TAGS.CHANGE_TO,
          preview,
          state,
        });
    }

    default: {
      const payload = [];

      switch (operation) {
        case OPERATIONS[channel].TAGS.CHANGE_TO: {
          if (getSize(preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]))) {
            payload.push(
              Map({
                type: operation,
                value: tagsToList({ channel, tags: preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]) }),
              })
            );
          } else if (preview.hasIn([ATTRIBUTE.TAGS, 'profile'])) {
            payload.push(
              Map({
                tagsProfileId: preview.getIn([ATTRIBUTE.TAGS, 'profile', 'profileId']),
                type: OPERATIONS[channel].TAGS.CHANGE_TO,
                value: tagsToList({ channel, tags: preview.getIn([ATTRIBUTE.TAGS, 'profile', ATTRIBUTE.TAGS]) }),
              })
            );
          }

          break;
        }

        default: {
          if (preview.hasIn([ATTRIBUTE.TAGS, 'profile'])) {
            payload.push(
              Map({
                tagsProfileId: preview.getIn([ATTRIBUTE.TAGS, 'profile', 'profileId']),
                type: OPERATIONS[channel].TAGS.CHANGE_TO,
                value: tagsToList({ channel, tags: preview.getIn([ATTRIBUTE.TAGS, 'profile', ATTRIBUTE.TAGS]) }),
              })
            );
          }

          if (getSize(preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]))) {
            payload.push(
              Map({
                type: operation,
                value: tagsToString({ channel, tags: preview.getIn([ATTRIBUTE.TAGS, ATTRIBUTE.TAGS]) }),
              })
            );
          }

          break;
        }
      }

      return {
        payload,
      };
    }
  }
}
